var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:[_vm.$style.button, {
    animate: _vm.clicked,
  }],on:{"click":_vm.click}},[_vm._t("default"),(_vm.hasLabel)?_c('span',{class:_vm.$style.buttonLabel},[_vm._t("label")],2):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }